import { getIdDisplayValue } from '@utils/index';
import { useLocationMapQuery, useLocationQuery, useNameMapQuery } from '@features/redux/apis/org';
import { Box, CircularProgress, Grid, Typography } from '@mui/material';
import { Locations as LocationsIcon } from '@assets/index';
import { useStyles } from './styles/ViewSystemLocation.styles';
import { ReadOnlyField } from '@components/design-system';
import { Link } from 'react-router-dom';
import { useOrgDetailLink } from '../../useOrgDetailLink';

type ViewSystemLocationProps = {
    locationId: number | null | undefined;
};

export const ViewSystemLocation = ({ locationId }: ViewSystemLocationProps) => {
    const classes = useStyles();
    const detailLink = useOrgDetailLink();
    const { data: nameMap } = useNameMapQuery({});
    const { data: locationMap } = useLocationMapQuery({});
    const { data: location, isLoading } = useLocationQuery({ locationId: locationId! }, { skip: !locationId });

    const { companyId, resellerId } = Object.fromEntries(locationMap?.locations || [])?.[locationId!] ?? {};

    return (
        <>
            {isLoading ? (
                <Box className={classes.box} height='200px'>
                    <CircularProgress size='75px' />
                </Box>
            ) : !locationId ? (
                <Box className={classes.box}>
                    <LocationsIcon />
                    <Typography fontWeight='bold'>This RapidCut system is not yet assigned to any location.</Typography>
                </Box>
            ) : (
                <Box display='flex' flexDirection='column' flex={1} gap={2}>
                    <Box display='flex' flexDirection='row' gap={1} alignItems='center'>
                        <Typography fontSize='0.875rem' color='text.secondary'>
                            Manage Location:
                        </Typography>
                        <Link to={detailLink('location', locationId!)}>
                            <Typography fontSize='0.875rem' color='primary'>
                                {nameMap?.locations[locationId]}
                            </Typography>
                        </Link>
                    </Box>

                    <Grid container spacing={2.5}>
                        <Grid item xs={12} md={6}>
                            <ReadOnlyField label='Location ID' value={getIdDisplayValue(location?.LocationID)} />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <ReadOnlyField label='Location Name' value={location?.LocationName || 'N/A'} />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <ReadOnlyField label='Company Name' value={nameMap?.companies[companyId] || 'N/A'} />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <ReadOnlyField
                                label='Reseller Name'
                                value={resellerId ? nameMap?.resellers[resellerId] || 'N/A' : 'N/A'}
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <ReadOnlyField label='Country' value={location?.Country || 'N/A'} />
                        </Grid>
                    </Grid>
                </Box>
            )}
        </>
    );
};
